// Copyright 2026. WebPros International GmbH. All rights reserved.

export const ANALYTICS_EVENTS = {
    ADMIN: {
        DASHBOARD: {
            VISIT: 'SVM_ADM:DASHBOARD_PAGE-SGL-VISIT',
        },
        ACTIVITY_LOGS: {
            VISIT: 'SVM_ADM:ACTIVITY_LOGS_PAGE-SGL-VISIT',
        },
        ACCOUNT: {
            VISIT: 'SVM_ADM:ACCOUNT_PAGE-SGL-VISIT',
        },
        API_TOKENS: {
            VISIT: 'SVM_ADM:API_TOKENS_PAGE-SGL-VISIT',
        },
        APPLICATION: {
            VISIT: 'SVM_ADM:APPLICATIONS_PAGE-SGL-VISIT',
            FORM_VISIT: 'SVM_ADM:APPLICATION_FORM_PAGE-SGL-VISIT',
        },
        AUTH: {
            LOGIN_BY_LINK: 'SVM_ADM:LOGIN_BY_LINK_PAGE-SGL-VISIT',
        },
        BACKUP: {
            VISIT: 'SVM_ADM:BACKUPS_PAGE-SGL-VISIT',
        },
        BACKUP_NODES: {
            VISIT: 'SVM_ADM:BACKUP_NODES_PAGE-SGL-VISIT',
        },
        CLUSTER_IMPORT: {
            VISIT: 'SVM_ADM:CLUSTER_IMPORT_PAGE-SGL-VISIT',
            COMPUTE_RESOURCES: {
                VISIT: 'SVM_ADM:CLUSTER_IMPORT_COMPUTE_RESOURCES_PAGE-SGL-VISIT',
            },
        },
        COMPUTE_RESOURCE: {
            VISIT: 'SVM_ADM:COMPUTE_RESOURCE_PAGE-SGL-VISIT',
            FORM_VISIT: 'SVM_ADM:COMPUTE_RESOURCE_FORM_PAGE-SGL-VISIT',
            INSTALLATION_ERROR: 'SVM_ADM:CONNECT_COMPUTE_RESOURCE-ERROR',
        },
        COMPUTE_RESOURCE_VMS: {
            VISIT: 'SVM_ADM:COMPUTE_RESOURCE_VMS_PAGE-SGL-VISIT',
        },
        COMPUTE_RESOURCE_VM: {
            VISIT: 'SVM_ADM:COMPUTE_RESOURCE_VMS_ID_PAGE-SGL-VISIT',
        },
        COMPUTE_RESOURCE_VM_CREATE: {
            VISIT: 'SVM_ADM:COMPUTE_RESOURCE_VMS_CREATE_PAGE-SGL-VISIT',
        },
        DISASTER_RECOVERY: {
            HISTORY_VISIT: 'SVM_ADM:DISASTER_RECOVERY_HISTORY_PAGE-SGL-VISIT',
            RESILIENCE_STATUS_VISIT: 'SVM_ADM:DISASTER_RECOVERY_RESILIENCE_STATUS_PAGE-SGL-VISIT',
        },
        EVENT_HANDLERS: {
            VISIT: 'SVM_ADM:SETTINGS_EVENT_HANDLERS_PAGE-SGL-VISIT',
        },
        EXTERNAL_INTEGRATIONS: {
            VISIT: 'SVM_ADM:EXTERNAL_INTEGRATIONS_PAGE-SGL-VISIT',
        },
        HELP: {
            VISIT: 'SVM_ADM:HELP_PAGE-SGL-VISIT',
        },
        ICONS: {
            VISIT: 'SVM_ADM:ICONS_PAGE-SGL-VISIT',
        },
        IMAGE_PRESETS: {
            VISIT: 'SVM_ADM:IMAGE_PRESETS_PAGE-SGL-VISIT',
        },
        IP_BLOCK: {
            VISIT: 'SVM_ADM:IP_BLOCK_PAGE-SGL-VISIT',
            ADDING_ERROR: 'SVM_ADM:ADD_IP_BLOCK-ERROR',
        },
        IP_TABLE: {
            VISIT: 'SVM_ADM:IP_TABLE_PAGE-SGL-VISIT',
        },
        ISO_IMAGES: {
            VISIT: 'SVM_ADM:ISO_IMAGES_PAGE-SGL-VISIT',
        },
        LANGUAGES: {
            VISIT: 'SVM_ADM:SETTINGS_LANGUAGES_PAGE-SGL-VISIT',
        },
        LICENSE: {
            VISIT: 'SVM_ADM:LICENSE_PAGE-SGL-VISIT',
            ACTIVATION_ERROR: 'SVM_ADM:ACTIVATE_LICENSE-ERROR',
        },
        LIMIT_GROUP: {
            VISIT: 'SVM_ADM:LIMIT_GROUPS_PAGE-SGL-VISIT',
        },
        LOCATION: {
            VISIT: 'SVM_ADM:LOCATIONS_PAGE-SGL-VISIT',
        },
        MANAGEMENT_NODE_BACKUPS: {
            VISIT: 'SVM_ADM:MANAGEMENT_NODE_BACKUPS_PAGE-SGL-VISIT',
        },
        MASS_MAILING: {
            VISIT: 'SVM_ADM:MASS_MAILING_PAGE-SGL-VISIT',
        },
        OFFERS: {
            VISIT: 'SVM_ADM:OFFERS_PAGE-SGL-VISIT',
        },
        OS_IMAGE: {
            VISIT: 'SVM_ADM:OS_IMAGES_PAGE-SGL-VISIT',
        },
        PLAN: {
            VISIT: 'SVM_ADM:PLANS_PAGE-SGL-VISIT',
            ADD_PLAN_ERROR: 'SVM_ADM:ADD_PLAN-ERROR',
        },
        ROLES: {
            VISIT: 'SVM_ADM:ROLES_PAGE-SGL-VISIT',
        },
        SETTINGS: {
            BILLING_INTEGRATION: {
                VISIT: 'SVM_ADM:SETTINGS_BILLING_INTEGRATION_PAGE-SGL-VISIT',
            },
            COMPUTE_RESOURCE: {
                VISIT: 'SVM_ADM:SETTINGS_COMPUTE_RESOURCE_PAGE-SGL-VISIT',
            },
            DNS: {
                VISIT: 'SVM_ADM:SETTINGS_DNS_PAGE-SGL-VISIT',
            },
            GENERAL: {
                VISIT: 'SVM_ADM:GENERAL_SETTINGS_PAGE-SGL-VISIT',
            },
            MAIL: {
                VISIT: 'SVM_ADM:SETTINGS_MAIL_PAGE-SGL-VISIT',
                ADD_MAIL_ERROR: 'SVM_ADM:MAIL_SETTINGS_ADD_MAIL-ERROR',
            },
            NETWORK_RULES: {
                VISIT: 'SVM_ADM:SETTINGS_NETWORK_RULES_PAGE-SGL-VISIT',
            },
            NOTIFICATIONS: {
                VISIT: 'SVM_ADM:SETTINGS_NOTIFICATIONS_PAGE-SGL-VISIT',
            },
            SYSTEM_UPDATES: {
                VISIT: 'SVM_ADM:SETTINGS_SYSTEM_UPDATES_PAGE-SGL-VISIT',
            },
            USER_AREA: {
                VISIT: 'SVM_ADM:SETTINGS_USER_AREA_PAGE-SGL-VISIT',
            },
            VPC_NETWORK: {
                VISIT: 'SVM_ADM:SETTINGS_VPC_NETWORK_PAGE-SGL-VISIT',
            },
            HIGH_AVAILABILITY: {
                VISIT: 'SVM_ADM:SETTINGS_HIGH_AVAILABILITY_PAGE-SGL-VISIT',
            },
        },
        SSH_KEYS: {
            VISIT: 'SVM_ADM:SSH_KEYS_PAGE-SGL-VISIT',
        },
        STORAGE_DISKS: {
            VISIT: 'SVM_ADM:STORAGE_DISKS_PAGE-SGL-VISIT',
        },
        STORAGE_TAGS: {
            VISIT: 'SVM_ADM:STORAGE_TAGS_PAGE-SGL-VISIT',
        },
        TAGS: {
            VISIT: 'SVM_ADM:SETTINGS_TAGS_PAGE-SGL-VISIT',
        },
        TASKS: {
            VISIT: 'SVM_ADM:TASKS_PAGE-SGL-VISIT',
        },
        UPDATES: {
            VISIT: 'SVM_ADM:UPDATES_PAGE-SGL-VISIT',
        },
        USERS: {
            VISIT: 'SVM_ADM:USERS_PAGE-SGL-VISIT',
        },
        VLANS: {
            VISIT: 'SVM_ADM:VLANS_PAGE-SGL-VISIT',
        },
        VPC_NETWORKS: {
            VISIT: 'SVM_ADM:VPC_NETWORKS_PAGE-SGL-VISIT',
            IPS: {
                VISIT: 'SVM_ADM:VPC_NETWORKS_IPS_PAGE-SGL-VISIT',
            },
        },
        DOCUMENTATION: {
            VISIT: 'SVM_ADM:DOCUMENTATION_PAGE-SGL-VISIT',
        },
    },
    ONBOARDING: {
        QUICK_START_BUTTON_VISIBLE: 'SVM_ADM:QS_QUICK_START_BUTTON-VISIBLE',
        WELCOME: {
            VISIT: 'SVM_ADM:QS_WELCOME_PAGE-SGL-VISIT',
            START_CLICKED: 'SVM_ADM:QS_START_BUTTON-CLICKED',
        },
        ACTIVATE_LICENSE: {
            VISIT: 'SVM_ADM:QS_ACTIVATE_LICENSE_PAGE-SGL-VISIT',
            FREE_TRIAL_CLICKED: 'SVM_ADM:QS_FREE_TRIAL_BUTTON-CLICKED',
            PORTAL_CLICKED: 'SVM_ADM:QS_SOLUSVM_PORTAL_BUTTON-CLICKED',
            SUPPORT_CLICKED: 'SVM_ADM:QS_SUPPORT_TEAM_BUTTON-CLICKED',
            SETTINGS_CLICKED: 'SVM_ADM:QS_SETTINGS_LICENSING_BUTTON-CLICKED',
            NEXT_CLICKED: 'SVM_ADM:QS_ACTIVATE_LICENSE_NEXT_BUTTON-CLICKED',
            CLOSE_CLICKED: 'SVM_ADM:QS_ACTIVATE_LICENSE_CLOSE_BUTTON-CLICKED',
        },
        ADD_COMPUTE_RESOURCE: {
            VISIT: 'SVM_ADM:QS_ADD_COMPUTE_RESOURCE_PAGE-SGL-VISIT',
            RESOURCES_CLICKED: 'SVM_ADM:QS_HOME_COMPUTE_RESOURCES_BUTTON-CLICKED',
            NEXT_CLICKED: 'SVM_ADM:QS_ADD_COMPUTE_RESOURCE_NEXT_BUTTON-CLICKED',
            CLOSE_CLICKED: 'SVM_ADM:QS_ADD_COMPUTE_RESOURCE_CLOSE_BUTTON-CLICKED',
        },
        CONNECT_COMPUTE_RESOURCE: {
            VISIT: 'SVM_ADM:QS_CONNECT_COMPUTE_RESOURCE_PAGE-SGL-VISIT',
            RETRY_CLICKED: 'SVM_ADM:QS_CONNECT_COMPUTE_RESOURCE_RETRY_BUTTON-CLICKED',
            NEXT_CLICKED: 'SVM_ADM:QS_CONNECT_COMPUTE_RESOURCE_NEXT_BUTTON-CLICKED',
            CLOSE_CLICKED: 'SVM_ADM:QS_CONNECT_COMPUTE_RESOURCE_CLOSE_BUTTON-CLICKED',
        },
        ADD_IP_BLOCK: {
            VISIT: 'SVM_ADM:QS_ADD_IP_BLOCK_PAGE-SGL-VISIT',
            NETWORK_CLICKED: 'SVM_ADM:QS_NETWORK_IP_BLOCKS_BUTTON-CLICKED',
            NEXT_CLICKED: 'SVM_ADM:QS_ADD_IP_BLOCK_NEXT_BUTTON-CLICKED',
            CLOSE_CLICKED: 'SVM_ADM:QS_ADD_IP_BLOCK_CLOSE_BUTTON-CLICKED',
        },
        ADD_VM_PLAN: {
            VISIT: 'SVM_ADM:QS_ADD_VM_PLAN_PAGE-SGL-VISIT',
            PLANS_CLICKED: 'SVM_ADM:QS_COMPUTE_RESOURCES_PLANS_BUTTON-CLICKED',
            NEXT_CLICKED: 'SVM_ADM:QS_ADD_VM_PLAN_NEXT_BUTTON-CLICKED',
            CLOSE_CLICKED: 'SVM_ADM:QS_ADD_VM_PLAN_CLOSE_BUTTON-CLICKED',
        },
        MAIL_SETTINGS: {
            VISIT: 'SVM_ADM:QS_MAIL_SETTINGS_PAGE-SGL-VISIT',
            SETTINGS_CLICKED: 'SVM_ADM:QS_SETTINGS_MAIL_BUTTON-CLICKED',
            SKIP_CLICKED: 'SVM_ADM:QS_MAIL_SETTINGS_SKIP_BUTTON-CLICKED',
            NEXT_CLICKED: 'SVM_ADM:QS_MAIL_SETTINGS_NEXT_BUTTON-CLICKED',
            CLOSE_CLICKED: 'SVM_ADM:QS_MAIL_SETTINGS_CLOSE_BUTTON-CLICKED',
        },
        CREATE_FIRST_VM: {
            VISIT: 'SVM_ADM:QS_CREATE_FIRST_VM_PAGE-SGL-VISIT',
            ADMIN_UI_CLICKED: 'SVM_ADM:QS_CREATE_FIRST_VM_ADMIN_UI_BUTTON-CLICKED',
            USER_UI_CLICKED: 'SVM_ADM:QS_CREATE_FIRST_VM_USER_UI_BUTTON-CLICKED',
            SAVE_AND_DONE_CLICKED: 'SVM_ADM:QS_CREATE_FIRST_VM_SAVE_AND_DONE_BUTTON-CLICKED',
            NEXT_CLICKED: 'SVM_ADM:QS_CREATE_FIRST_VM_NEXT_BUTTON-CLICKED',
            CLOSE_CLICKED: 'SVM_ADM:QS_CREATE_FIRST_VM_CLOSE_BUTTON-CLICKED',
        },
        BUTTON_CLICKED: 'SVM_ADM:QS_BUTTON-CLICKED',
        NEED_HELP_CLICKED: 'SVM_ADM:QS_NEED_HELP_BUTTON-CLICKED',
        DONE_CLICKED: 'SVM_ADM:QS_DONE_BUTTON-CLICKED',
        SKIP_CLICKED: 'SVM_ADM:QS_SKIP_BUTTON-CLICKED',
    },
    USER: {
        PROJECTS: {
            VISIT: 'SVM_USR:PROJECTS_PAGE-SGL-VISIT',
            PROJECT_ITEM_PAGE_VISIT: 'SVM_USR:PROJECT_ITEM_PAGE-SGL-VISIT',
            PROJECT_FORM_VISIT: 'SVM_USR:PROJECT_FORM_PAGE-SGL-VISIT',
            SERVERS_PAGE_VISIT: 'SVM_USR:SERVERS_PAGE-SGL-VISIT',
            SERVER_CREATE_PAGE_VISIT: 'SVM_USR:PROJECT_SERVER_CREATE_PAGE-SGL-VISIT',
            SERVER_ITEM_PAGE_VISIT: 'SVM_USR:PROJECT_SERVER_ITEM_PAGE-SGL-VISIT',
        },
        VPC_NETWORKS: {
            VPC_NETWORKS_PAGE_VISIT: 'SVM_USR:VPC_NETWORKS_PAGE-SGL-VISIT',
            VPC_NETWORKS_IPS_PAGE_VISIT: 'SVM_USR:VPC_NETWORKS_IPS_PAGE-SGL-VISIT',
        },
        ACCOUNT: {
            VISIT: 'SVM_USR:ACCOUNT_PAGE-SGL-VISIT',
        },
        ISO_IMAGES: {
            VISIT: 'SVM_USR:ISO_IMAGES_PAGE-SGL-VISIT',
        },
    },
};